import React, {useCallback, useState} from 'react';

import {ErrorBoundary} from '@sentry/react';
import {useEventTracking} from 'src/hooks/useEventTracking';

import {FlatButton} from '@pb/kit-component-button';
import {Dialog} from '@pb/kit-component-dialog-v2';
import {DropdownMenu, DropdownMenuItem} from '@pb/kit-component-dropdown-menu';
import Icon, {Icons} from '@pb/kit-component-icon';


import {DISABLE_ACCESS_RIGHTS, ENABLE_ACCESS_RIGHTS} from './constants';
import {PermissionsModal} from './permissions-modal';

type Props = {
    userIds: number[],
};

export const UpdateUserRights = ({userIds}: Props) => {
    const {bulkOpen} = useEventTracking();
    const {bulkSubmit} = useEventTracking();

    const [enableRightsShown, setEnableRightsShown] = useState(false);
    const [disableRightsShown, setDisableRightsShown] = useState(false);

    const openEnableRightsModal = useCallback(() => {
        setEnableRightsShown(true);
        bulkOpen({toolName: ENABLE_ACCESS_RIGHTS});
    }, [bulkOpen]);

    const closeEnableRightsModal = useCallback((submit: boolean) => {
        setEnableRightsShown(false);
        bulkSubmit({toolName: ENABLE_ACCESS_RIGHTS, submit});
    }, [bulkSubmit]);

    const openDisableRightsModal = useCallback(() => {
        setDisableRightsShown(true);
        bulkOpen({toolName: DISABLE_ACCESS_RIGHTS});
    }, [bulkOpen]);

    const closeDisableRightsModal = useCallback((submit: boolean) => {
        setDisableRightsShown(false);
        bulkSubmit({toolName: DISABLE_ACCESS_RIGHTS, submit});
    }, [bulkSubmit]);

    return (
        <ErrorBoundary>
            <DropdownMenu anchor={({positionRef, getAnchorProps, anchorRef}) => (
                <FlatButton
                    endIcon={<Icon type={Icons.ANGLE_DOWN} ref={positionRef}/>}
                    {...getAnchorProps()}
                    ref={anchorRef}>
                    <b>Set Permissions</b>
                </FlatButton>
            )}>
                <DropdownMenuItem
                    caption={ENABLE_ACCESS_RIGHTS}
                    onClick={openEnableRightsModal}
                />
                <DropdownMenuItem
                    caption={DISABLE_ACCESS_RIGHTS}
                    onClick={openDisableRightsModal}
                />
            </DropdownMenu>
            <Dialog
                shown={enableRightsShown}
                setShown={() => closeEnableRightsModal(false)}
                wrapperProps={{style: {width: 1200}}}>
                <PermissionsModal
                    enable={true}
                    userIds={userIds}
                    onCloseModal={() => closeEnableRightsModal(false)}
                />
            </Dialog>
            <Dialog
                shown={disableRightsShown}
                setShown={() => closeDisableRightsModal(false)}
                wrapperProps={{style: {width: 1200}}}>
                <PermissionsModal
                    enable={false}
                    userIds={userIds}
                    onCloseModal={() => closeDisableRightsModal(false)}
                />
            </Dialog>
        </ErrorBoundary>
    );
};
